type MaybeFullName = { first?: string | null; last?: string | null } | null | undefined;

export const formatFullName = (fullName: MaybeFullName) =>
  [fullName?.first, fullName?.last].filter(Boolean).join(' ');

export const displayName = (user: { fullName?: MaybeFullName; preferredName?: MaybeFullName }) =>
  formatFullName(user.preferredName) || formatFullName(user.fullName);
